import "./application.scss";
import "preline";
import "@hotwired/turbo-rails";
import "./controllers";
import toast from "../javascript/toast.js";

// Export toast to global scope for Turbo Stream scripts
window.toast = toast;

// Watch for toast triggers added by Turbo Streams
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-toast-trigger')) {
        const message = node.getAttribute('data-message');
        if (message && window.toast) {
          window.toast.success(message);
          node.remove();
        }
      }
    });
  });
});

// Start observing the toast container
document.addEventListener('DOMContentLoaded', () => {
  const toastContainer = document.getElementById('toast-container');
  if (toastContainer) {
    observer.observe(toastContainer, { childList: true, subtree: true });
  }
});

// Also start on turbo:load for SPA navigation
document.addEventListener('turbo:load', () => {
  const toastContainer = document.getElementById('toast-container');
  if (toastContainer && !toastContainer.dataset.observing) {
    observer.observe(toastContainer, { childList: true, subtree: true });
    toastContainer.dataset.observing = 'true';
  }
});

// Import images to make them available
import.meta.glob("/images/previews/**/current.png", { eager: true });

// Prevent frame missing errors
document.addEventListener("turbo:frame-missing", (event) => {
  event.preventDefault();
});

// Initialize Preline on Turbo navigation
document.addEventListener("turbo:load", () => {
  if (window.HSStaticMethods) {
    window.HSStaticMethods.autoInit();
  }
});

document.addEventListener("turbo:render", () => {
  if (window.HSStaticMethods) {
    window.HSStaticMethods.autoInit();
  }
});

console.log("Vite ⚡️ Rails");
